<template>
	<div>

		<app-token-card v-for="token in tokens"
		                :key="token.tokenId"
		                :token="token"
		                :account="account"
		                :is-admin="isAdmin">
		</app-token-card>
	</div>
</template>

<script>
	import TokenCard from "@/components/token/TokenCard";

	export default {
		props: ['isAdmin', 'account', 'destination', 'tokens'],
		components: {
			appTokenCard: TokenCard
		}
	}
</script>

<style scoped>

</style>